import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import type { AreaPractica } from "../../shared/types";
import { useAuth } from "../auth/AuthContext";
import { Boton } from "../components/Boton";
import { Select } from "../components/Formulario";
import { Icono } from "../components/Icono";
import { api } from "../lib/apiClient";

const ETIQUETA_ROL: Record<string, string> = {
  ADMINISTRADOR: "Administrador",
  ABOGADO: "Abogado",
  ADMINISTRATIVO: "Administrativo",
};

const FOCO = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secundario focus-visible:ring-offset-2";

export function Header({ onAbrirMenu }: { onAbrirMenu: () => void }) {
  const { usuario, cerrarSesion, areaSeleccionada, setAreaSeleccionada } = useAuth();
  const navegar = useNavigate();
  const [areas, setAreas] = useState<AreaPractica[]>([]);

  useEffect(() => {
    if (usuario?.rol !== "ADMINISTRADOR") return;
    api
      .get<{ items: AreaPractica[] }>("/catalogos-estudio/areas-practica")
      .then((d) => setAreas(d.items.filter((a) => a.activo)))
      .catch(() => undefined);
  }, [usuario?.rol]);

  async function manejarLogout() {
    await cerrarSesion();
    navegar("/login", { replace: true });
  }

  if (!usuario) return null;

  return (
    <header className="fixed inset-x-0 top-0 z-30 flex h-14 items-center justify-between border-b border-borde bg-superficie/80 px-4 backdrop-blur lg:pl-60 lg:pr-6">
      <button
        type="button"
        onClick={onAbrirMenu}
        aria-label="Abrir menú"
        className={`flex h-9 w-9 items-center justify-center rounded-lg text-texto-secundario transition-colors hover:bg-fondo lg:hidden ${FOCO}`}
      >
        <Icono nombre="menu" className="h-5 w-5" />
      </button>
      <div className="flex items-center gap-3">
        {usuario.rol === "ADMINISTRADOR" && areas.length > 0 && (
          <Select
            value={areaSeleccionada ?? ""}
            onChange={(e) => setAreaSeleccionada(e.target.value || null)}
            className="w-auto py-1.5 text-sm"
            aria-label="Ver Unidad de Negocio"
          >
            <option value="">Ver: Todas</option>
            {areas.map((a) => (
              <option key={a.id} value={a.id}>
                Ver: {a.nombre}
              </option>
            ))}
          </Select>
        )}
        <div className="text-right">
          <p className="text-sm font-medium leading-tight text-texto">{usuario.nombre_completo}</p>
          <p className="text-xs leading-tight text-texto-secundario">{ETIQUETA_ROL[usuario.rol] ?? usuario.rol}</p>
        </div>
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-borde text-xs font-semibold text-texto">
          {usuario.nombre_completo.charAt(0).toUpperCase()}
        </div>
        <Boton variante="fantasma" tamano="sm" onClick={manejarLogout}>
          Salir
        </Boton>
      </div>
    </header>
  );
}
